
  document.addEventListener('DOMContentLoaded', (event) => {
    const buttonsPanel = document.querySelector('.buttons-panel');
    const backToTopBtn = document.getElementById('back-to-top-button');
    const filterBtnContainer = document.getElementById('blog-filters-button-container');
    const closeFiltersBtn = document.querySelectorAll('.close-filters-btn');
    const clearFiltersBtns = document.querySelectorAll('.clear-filters-btn');
    const closeFiltersXButton = document.getElementById('closeFiltersXButton');
    const blogFiltersOverlay = document.getElementById('blog-filters-overlay');
    const body = document.body;
    const header = document.querySelector('header');
    const main = document.querySelector('main');
    const filtersContainer = document.getElementById('blog-filters-container');
    const cursorRounded = document.querySelectorAll('.rounded-button');
    const closingArea = document.getElementById('filters-closing-area');
    const activeFiltersCount = document.getElementById('selected-filters-count');

    setTimeout(() => {
      buttonsPanel.classList.remove('fade-in');
      buttonsPanel.classList.add('opacity-visible');
    }, 100);

    filterBtnContainer.addEventListener('click', toggleFilterOverlay);

    function toggleFilterOverlay() {
      if (blogFiltersOverlay.classList.contains('hidden')) {
        openFilterOverlay();
      } else {
        closeFilterOptions();
      }
    }

    function openFilterOverlay() {
      blogFiltersOverlay.classList.remove('hidden');
      blogFiltersOverlay.classList.add('fade-in-transition');
      main.classList.remove('transition-all', 'duration-600', 'ease-in-out');
      header.classList.add('md:z-0', 'md:!relative');
      main.classList.add('md:!pt-0');
      header.classList.remove('z-20', 'z-30');

      setTimeout(() => {
        blogFiltersOverlay.classList.remove('opacity-0');
        blogFiltersOverlay.classList.remove('fade-out-transition');
        filtersContainer.classList.add('slide-up-transition-active');
        filterBtnContainer.classList.replace('bg-grey-850','bg-grey-1000');
        closeFiltersXButton.classList.replace('md:hidden','md:flex');
      }, 200);

      setTimeout(() => {
        header.classList.add('hidden', 'md:flex');
      }, 550);
      body.classList.add('no-scroll');
    }

    function closeFilterOptions() {
      blogFiltersOverlay.classList.replace('fade-in-transition', 'fade-out-transition');
      filtersContainer.classList.replace('slide-up-transition-active', 'slide-down-transition-active');
      filterBtnContainer.classList.replace('bg-grey-1000', 'bg-grey-850');
      closeFiltersXButton.classList.add('md:hidden');
      header.classList.remove('hidden');
      header.classList.remove('md:z-0', 'md:!relative');
      main.classList.remove('md:!pt-0');

      setTimeout(() => {
        main.classList.add('transition-all', 'duration-600', 'ease-in-out');
      }, 550);

      setTimeout(() => {
      blogFiltersOverlay.classList.add('hidden');
      blogFiltersOverlay.classList.add('opacity-0');
      filtersContainer.classList.remove('slide-down-transition-active', 'slide-up-transition-active');
      }, 600);
     body.classList.remove('no-scroll');
    }

    clearFiltersBtns.forEach((clearFiltersBtn) => {
      clearFiltersBtn.addEventListener('click', (event) => {
          event.stopPropagation();
      });
  });

    backToTopBtn.addEventListener('click', (event) => {
      closeFilterOptions();
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });

    closeFiltersBtn.forEach((button) => {
      button.addEventListener('click', (event) => {
        closeFilterOptions();
      });
    });

    const moveCursor = (e) => {
      cursorRounded.forEach((cursor) => {
        cursor.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
        cursor.style.display = 'flex';
      });
    };

    closingArea.addEventListener('mouseenter', function () {
      window.addEventListener('mousemove', moveCursor);
    });

    closingArea.addEventListener('mouseleave', function () {
      window.removeEventListener('mousemove', moveCursor);
      cursorRounded.forEach((cursor) => {
        cursor.style.display = 'none';
      });
    });
    closingArea.addEventListener('click', function () {
      closeFilterOptions();
    });

   async function handleTagClick(tag, remove) {
      const storeEndpoint = window.location.protocol + '//' + window.location.host;

      tag = tag
        .toLowerCase()
        .replace(/&/g, '')
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '');

      let url = new URL(window.location.href);
      let pathname = url.pathname;
      let tags = pathname.split('/tagged/')[1] ? pathname.split('/tagged/')[1].split('+') : [];

      if (remove) {
        tags = tags.filter((t) => t !== tag);
      } else if (!tags.includes(tag)) {
          tags.push(tag);
      }

      let newPath = pathname.split('/tagged/')[0];
      if (tags.length > 0) {
        newPath += `/tagged/${tags.join('+')}`;
      }
      window.history.pushState({}, '', newPath);

      let counter = 0;

      const endpoint = `${storeEndpoint}${newPath}`;

     await fetch(endpoint)
        .then((res) => res.text())
        .then((data) => {
          const container = document.querySelector('.cards-grid');
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, 'text/html');
          const grid = doc.querySelector('.cards-grid');
          const pagination = document.querySelector('#blog-pagination');
          const newPagination = doc.querySelector('#blog-pagination');
          const articleCountElements = document.querySelectorAll('.article-count');
          const newArticleCount = doc.querySelector('.article-count'); 

          container.innerHTML = '';

          grid.childNodes.forEach((element) => {
            if (element.nodeType === 1) {
              container.appendChild(element);
              counter ++
            }
          });

          if (articleCountElements.length > 0) {
            articleCountElements.forEach(articleCount => {
              articleCount.innerHTML = newArticleCount.innerHTML;
            });
          }

          if (newPagination) {
           pagination.innerHTML = newPagination.innerHTML;
          }

          const allArticlesElement = document.getElementById('allArticles');
          if (allArticlesElement) {
            const elementPosition = allArticlesElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 72;
          
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }

          updateCategoriesHeader();
          bindTagEventListeners();
          document.dispatchEvent(new CustomEvent('reUpdateImageSrc'));
        });
    }

    function bindTagEventListeners() {
      document.querySelectorAll('.filters-container').forEach((container) => {
        container.removeEventListener('click', handleTagClickEvent);
        container.addEventListener('click', handleTagClickEvent);
      });
      cardHoverAnimation('.blog-article-card', '.blog-article-img');
    }

    function handleTagClickEvent(event) {
      const element = event.target.closest('.filter-tag');
      if (element) {
        const tag = element.getAttribute('data-tag');
        const remove = element.getAttribute('data-active') === 'true';
        const removeValue = !remove;

        document.querySelectorAll(`[data-tag="${tag}"]`).forEach((tagElement) => {
          tagElement.setAttribute('data-active', removeValue);

          if (removeValue) {
            tagElement.classList.add('bg-grey-1000', 'text-grey-0');
          } else {
            tagElement.classList.remove('bg-grey-1000', 'text-grey-0');
          }
        });

        handleTagClick(tag, remove);
        getActiveTags();
      }
      applyOpacityToOtherCategories();
    }

    function getActiveTags() {
      const taggedPart = window.location.pathname.split('/tagged/')[1];
      let baseUrl = window.location.origin + window.location.pathname.split('/tagged/')[0];
      const activeTags = taggedPart ? taggedPart.split('+') : [];
      const clearFiltersBtn = document.querySelectorAll('.clear-filters-btn');
      const iconCrossHTML = document.getElementById('icon-cross-template').innerHTML;

      if (activeFiltersCount && activeTags.length > 0) {
        activeFiltersCount.innerHTML = `(${activeTags.length})`;

        const buttonContent = `
        <span id="clearAllBtn" class="text-grey-650 flex flex-row items-center self-center gap-spacing-xs">
          <span>${iconCrossHTML}</span>
          <a href="${baseUrl}" class="uppercase functional-regular">Clear all</a>
        </span>`;

        clearFiltersBtn.forEach(btn => btn.innerHTML = buttonContent); 
      } else if (activeTags.length === 0) {
        activeFiltersCount.innerHTML = '';
        clearFiltersBtn.forEach(btn => btn.innerHTML = '');
      }
    }
    getActiveTags();
    bindTagEventListeners();

    function cardHoverAnimation(cardsSelector, imgSelector) {
      const cards = document.querySelectorAll(cardsSelector);
  
      cards.forEach(card => {
          const images = document.querySelectorAll(imgSelector);
  
          card.addEventListener('mouseover', () => {
              images.forEach(image => {
                  if (!card.contains(image)) {
                      image.classList.add('opacity-75', 'duration-600', 'cubic');
                  } else {
                    image.classList.remove('opacity-75');
                  }
              });
          });
  
          card.addEventListener('mouseout', () => {
              images.forEach(image => {
                  if (!card.contains(image)) {
                      image.classList.remove('opacity-75');
                      applyOpacityToOtherCategories()
                  }
              });
          });
      });
   }
  
    cardHoverAnimation('.blog-article-card', '.blog-article-img');
    cardHoverAnimation('.blog-category-card', '.blog-category-img');

    function applyOpacityToOtherCategories() {
      const categories = ['news', 'lifestyle', 'about-jo'];
      const url = window.location.href.toLowerCase();;
      let matchedCategory;
  
      categories.forEach(category => {
          if (url.includes(category)) {
              matchedCategory = category;
          }
      });

      if (matchedCategory) {
        const categoryCards = document.querySelectorAll('.blog-category-card');
        categoryCards.forEach(card => {
            const images = card.querySelectorAll('.blog-category-img');
    
            images.forEach(image => {
                const cardClasses = image.className.toLowerCase().split(' ');
                const cardHasMatchingCategory = cardClasses.includes(`category-${matchedCategory}`);
    
                if (!cardHasMatchingCategory) {
                    image.classList.add('opacity-75', 'duration-600', 'cubic');
                } else {
                    image.classList.remove('opacity-75', 'duration-600', 'cubic');
                }
            });
        });
      } else {
        const categoryCards = document.querySelectorAll('.blog-category-card');
        categoryCards.forEach(card => {
            const images = card.querySelectorAll('.blog-category-img');
            images.forEach(image => {
                image.classList.remove('opacity-75', 'duration-600', 'cubic');
            });
        });
      }
    }
   applyOpacityToOtherCategories();

  function updateCategoriesHeader() {
    const headingElement = document.getElementById('allArticles');
    const url = window.location.href.toLowerCase();
    const categories = ['news', 'lifestyle', 'about-jo'];
    let matchedCategories = []; 
  
    categories.forEach(category => {
        if (url.includes(category)) {
            if (category === 'about-jo') {
                matchedCategories.push('About Jo');
            } else {
                matchedCategories.push(category.charAt(0).toUpperCase() + category.slice(1));
            }
        }
    });

    let matchedCategoryText;
    if (matchedCategories.length === 0) {
        matchedCategoryText = 'All Articles';
    } else if (matchedCategories.length === 1) {
        matchedCategoryText = matchedCategories[0];
    } else {
        matchedCategoryText = matchedCategories.join(' & ');
    }
    headingElement.textContent = matchedCategoryText;
  }

  updateCategoriesHeader();
});
  

